import React, { useEffect, useState } from 'react';

import { SalaryHistoryDbType } from '../../../api/types/accountants/salary-history/salary-history.type';
import { SalaryHistorySideBar } from './components/salary-history-side-bar';
import { SalaryHistoryTable } from './components/salary-history-table';
import { getSalaryHistoryOperations } from './operations/get-salary-history-operations';

export const SalaryHistory = () => {
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);

  const [salariesData, setSalariesData] = useState<SalaryHistoryDbType[]>([]);

  useEffect(() => {
    const fetchHistory = async () =>
      await getSalaryHistoryOperations(
        new Date(2025, 6, 1),
        new Date(2025, 7, 1),
        setSalariesData,
      );
    fetchHistory();
  }, []);

  const handleDateRangeChange = (
    newStartDate: Date | null,
    newEndDate: Date | null,
  ) => {
    setStartDate(newStartDate);
    setEndDate(newEndDate);

    if (newStartDate && newEndDate) {
      getSalaryHistoryOperations(newStartDate, newEndDate, setSalariesData);
    }
  };

  return (
    <div style={{ display: 'flex', gap: '16px', paddingTop: '16px' }}>
      <SalaryHistorySideBar
        startDate={startDate}
        endDate={endDate}
        onDateRangeChange={handleDateRangeChange}
      />
      <div style={{ flex: 1 }}>
        <SalaryHistoryTable salariesData={salariesData} />
      </div>
    </div>
  );
};
